<template>
  <div class="d-flex align-items-center justify-content-center glassy-bg" style="height: 100vh">
    <div class="auth-card card bg-light shadow-lg border-0">
      <div class="card-header bg-primary position-relative">
        <div class="avatar position-absolute top-100 start-50 translate-middle">
          <img src="@/assets/images/user_2x.png" width="112" alt="" />
        </div>
      </div>
      <div class="card-body mt-5 pb-3">
        <h5 class="fs-4 fw-bold text-center mb-0 pt-3">أهلا بك مجددا</h5>
        <button class="btn btn-primary d-flex align-items-center justify-content-center gap-2 mx-auto my-4 fs-14px p-0">
          <div class="bg-light rounded-2 d-flex align-items-center justify-content-center" style="width: 35px; height: 35px">
            <img src="@/assets/images/google-icon.svg" alt="" />
          </div>
          <span class="pe-3">الدخول بإستخدام جوجل</span>
        </button>

        <div class="seperator">
          <div class="line">
            <span class="bg-light p-2 text-black fs-14px">او</span>
          </div>
        </div>
        <div class="mt-5">
          <div class="mb-3">
            <label class="fs-14px text-black">البريد</label>
            <input type="email" placeholder="name@name.com" class="form-control py-2" />
          </div>
          <div class="mb-3">
            <label class="fs-14px text-black">الرمز</label>
            <input type="password" class="form-control py-2" placeholder="XXXXXX" />
          </div>
        </div>
        <div class="d-grid mb-3">
          <button class="btn btn-primary rounded-pill py-2">تسجيل الدخول</button>
        </div>
        <div class="text-center text-secondary fs-14px">
          ليس لديك حساب؟
          <router-link :to="{name: 'Register'}" class="text-primary">أنشئ حسابك الآن</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    document.body.classList.add('glassyBg')
  },
  destroyed() {
    document.body.classList.remove('glassyBg')
  },
}
</script>

<style>
</style>